import { useState } from 'react'
import { Link } from 'react-router-dom'
import { EnrollmentModal } from '../../components/EnrollmentModal'

export function Terms() {
  const [enrollmentModalOpen, setEnrollmentModalOpen] = useState(false)

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl sm:text-2xl font-bold text-blue-600">EMR</Link>
            <div className="flex items-center space-x-4">
              <Link to="/login" className="text-gray-700 hover:text-blue-600 transition">Sign In</Link>
              <button
                onClick={() => setEnrollmentModalOpen(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        <p className="text-gray-600 mb-8">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

        <div className="prose prose-lg max-w-none text-gray-700 space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using EMR System's electronic medical records platform ("Service"), you agree to be bound
              by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
            <p>
              EMR System provides a cloud-based electronic medical records platform for healthcare providers, including:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Patient record management and clinical documentation</li>
              <li>Billing and claims submission</li>
              <li>E-prescribing and medication management</li>
              <li>Appointment scheduling and patient communication</li>
              <li>Reporting and analytics</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. User Responsibilities</h2>
            <p>As a user of our Service, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the confidentiality of your account credentials</li>
              <li>Use the Service in compliance with all applicable healthcare laws and regulations</li>
              <li>Ensure appropriate authorization before accessing patient records</li>
              <li>Report any security incidents or unauthorized access immediately</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Data Ownership</h2>
            <p>
              <strong>Your Data:</strong> You retain all rights to patient data and clinical information entered into the Service.
              We do not claim ownership of your data and will not sell or share it for commercial purposes.
            </p>
            <p className="mt-4">
              <strong>Data Portability:</strong> You may export your data at any time in standard formats (HL7 FHIR, CSV, PDF)
              at no additional cost. There are no data lock-in fees or export charges.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Service Level Agreement</h2>
            <p>We commit to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>99.9% uptime availability</li>
              <li>Response time under 2 seconds for standard operations</li>
              <li>24/7 emergency support for critical issues</li>
              <li>Regular security updates and maintenance</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Prohibited Uses</h2>
            <p>You may not use the Service to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Violate any healthcare privacy laws (HIPAA, PIPEDA, etc.)</li>
              <li>Access patient records without proper authorization</li>
              <li>Interfere with or disrupt the Service or servers</li>
              <li>Attempt to gain unauthorized access to any systems</li>
              <li>Use the Service for any unlawful purpose</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, EMR SYSTEM SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
              SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SERVICE.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Termination</h2>
            <p>
              Either party may terminate this agreement with 30 days written notice. Upon termination, you will have
              90 days to export your data. After this period, your data will be securely deleted in accordance with
              our data retention policies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact</h2>
            <p>
              For questions about these Terms, contact us at:<br />
              Email: legal@emrsystem.com<br />
              Address: 123 Healthcare Drive, Toronto, ON M5V 1A1, Canada
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/" className="text-white hover:text-blue-400 transition">← Back to Home</Link>
          <p className="mt-4 text-sm">&copy; {new Date().getFullYear()} EMR System. All rights reserved.</p>
        </div>
      </footer>

      <EnrollmentModal
        isOpen={enrollmentModalOpen}
        onClose={() => setEnrollmentModalOpen(false)}
      />
    </div>
  )
}

